/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    component: () =>
      import(
        /* webpackChunkName: "challenges" */ '@/modules/challenges/scenes/challenges-list/challenges-list.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.CHALLENGES.CHALLENGES_LIST,
    path: 'challenges'
  },
  {
    component: () =>
      import(
        /* webpackChunkName: "challenges" */ '@/modules/challenges/scenes/challenges-detail/challenges-detail.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.CHALLENGES.CHALLENGES_DETAIL,
    path: 'challenges/:id'
  }
] as RouteConfig[];
